// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * SolyticsListStandard.jsx
 * INTERNAL COMPONENT - Renders standard, non-virtualized lists.
 */
import React from 'react';
import SolyticsGrid from '../../SolyticsGrid';
import SolyticsListItem from '../../SolyticsListItem';

const SolyticsListStandard = ({
  items,
  variant,
  dense,
  gap,
  orientation,
  enableDragAndDrop,
  handleDrop,
}) => {
  return (
    <SolyticsGrid
      container
      direction={orientation === 'horizontal' ? 'row' : 'column'}
      sx={{
        position: 'relative',
        wrap: 'nowrap',
        height: 'auto',
        width: '100%',
        gap: gap,
      }}
    >
      {items.map((item, index) => (
        <SolyticsListItem
          key={item.id ?? `list-item-${index}`}
          index={index}
          item={{ dense, variant, ...item }}
          draggable={enableDragAndDrop}
          onDrop={handleDrop}
        />
      ))}
    </SolyticsGrid>
  );
};

export default SolyticsListStandard;
